import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpParams, HttpRequest } from "@angular/common/http";
import { from, Observable } from "rxjs";
import { Configuration } from "../../assets/Configuration";
import { FolderCreationModel } from "../models/folder-creation.model";
import { FileModel } from "../models/file.model";
import { CreateUploadSessionResponse } from '../models/create-upload-session-response.model';
import { BlobUploadCommonResponse, BlockBlobClient } from "@azure/storage-blob";
import { UploadSessionCreationModel } from '../models/upload-session-creation.model';

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {

  constructor(
    private httpClient: HttpClient
  ) {
  }

  private static readonly BLOCK_SIZE = 4 * 1024 * 1024; // 4 MB
  private static readonly MAX_CONCURRENCY = 4;
  private static readonly MAX_SINGLE_SHOT_SIZE = 4 * 1024 * 1024; // 4 MB

  public createFolder(folderCreationModel: FolderCreationModel): Observable<FileModel> {
    return this.httpClient.post<FileModel>(Configuration.getApiBaseUrl() + "/fileuploader/create-folder", folderCreationModel);
  }

  public uploadToFolder(folderId: string, fullPath: string, blob: Blob): Observable<any> {
    const url =  `${Configuration.getApiBaseUrl()}/fileuploader/upload-to-folder`;
    
    const formData: FormData = new FormData();
    formData.append('file', blob, fullPath);

    const params = new HttpParams()
      .set('folderId', folderId);

    const request = new HttpRequest('POST', url, formData, {
      reportProgress: true,
      params: params
    });
    
    return this.httpClient.request<any>(request);
  }

  public uploadFile(file: File, uploadStatusIdentifier: string): Observable<HttpEvent<FileModel>> {
    const url = `${Configuration.getApiBaseUrl()}/fileuploader/upload-file`;

    const params = new HttpParams()
      .set('fileName', file.name)
      .set('uploadStatusIdentifier', uploadStatusIdentifier);

    const req = new HttpRequest('POST', url, file, {
      reportProgress: true,
      params: params,
    });

    return this.httpClient.request<FileModel>(req);
  }

  createUploadSession(
    model: UploadSessionCreationModel
  ): Observable<CreateUploadSessionResponse> {

    return this.httpClient.post<CreateUploadSessionResponse>(
      Configuration.getApiBaseUrl() + "/fileuploader/create-upload-session",
      model
    );
  }

  uploadDirectlyToBlob(
    sasUrl: string,
    file: File,
    onProgress: (percent: number) => void
  ): Observable<BlobUploadCommonResponse> {

    const blobClient = new BlockBlobClient(sasUrl);

    return from(
      blobClient.uploadData(file, {
        blockSize: FileUploadService.BLOCK_SIZE,
        concurrency: FileUploadService.MAX_CONCURRENCY,
        maxSingleShotSize: FileUploadService.MAX_SINGLE_SHOT_SIZE, 
        blobHTTPHeaders: {
          blobContentType: file.type
        },
        onProgress: e => {
          console.log(e.loadedBytes, file.size);
          const percent = e.loadedBytes / file.size * 100;
          onProgress(percent);
        }
      })
    );
  }
    
  completeUpload(
    uploadId: string
  ): Observable<FileModel> {
    return this.httpClient.post<FileModel>(
      Configuration.getApiBaseUrl() + `/fileuploader/complete-upload/${uploadId}`,
      {}
    );
  }
}
